module.exports = __webpack_public_path__ + "img/ams.ad044efd.png";